import EditComponent from './MerchantOrderTypeEdit';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';
import { Switch } from 'antd';

//组件 
const WebComponent = (props: any) => {

    /** api服务id */
    const apiId = 'merchantOrderType';

    //表头
    const columnsHead = [
        {
            title: '类型名',
            dataIndex: 'orderTypeName'
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '商户订单类型',
        apiId,
        columns,
        showStates: true,
        EditComponent
    };

    return (
        <WebUniversal props={extendProps} />
    )
}

export default WebComponent;
